import {ChecklistItem, TaskReorderParams, UpdateFields} from '@/interfaces/TaskInterfaces';
import {HTTP} from '@/utils/httpCommonUtil';

export async function updateTask(taskId: number, field: UpdateFields, body: { oldValue?: any, newValue: any, other?: any }): Promise<boolean> {
  const response = await HTTP.put(`/api/tasks/${taskId}/${field}`, body);
  if (response.data.success) {
    return true;
  }
  throw new Error(response.data.message);
}

export async function reorderTask(taskId: number, body: TaskReorderParams) : Promise<boolean>{
  const response = await HTTP.put(`/api/tasks/${taskId}/order`, body);
  if (response.data.success) {
    return true;
  }
  throw new Error(response.data.message);
}

export async function addTaskChecklistItem(taskId: number, data: any) {
  const response = await HTTP.post(`/api/tasks/${taskId}/checklist-items`, data);
  if (response.data.success) {
    return true;
  }
  throw new Error(response.data.message);
}

export async function updateTaskChecklistItem(taskId: number, item: ChecklistItem) {
  const response = await HTTP.put(`/api/tasks/${taskId}/checklist-items/${item.id}`, { note: item.note, isComplete: item.isComplete, updatedDatetime: item.updatedDatetime });
  if (response.data.success) {
    return true;
  }
  throw new Error(response.data.message);
}

export async function deleteTaskChecklistItem(taskId: number, itemId: number) {
  const response = await HTTP.delete(`/api/tasks/${taskId}/checklist-items/${itemId}`);
  if (response.data.success) {
    return true;
  }
  throw new Error(response.data.message);
}

export async function createChecklistTemplate(taskId: number, name: string, visibleToSecurityRoleId: number) {
  const response = await HTTP.post('/api/task-checklist-templates', { taskId, name, visibleToSecurityRoleId });
  if (response.data.success) {
    return true;
  }
  throw new Error(response.data.message);
}

export async function deleteTaskChecklistTemplate(templateId: number) {
  const response = await HTTP.delete(`/api/task-checklist-templates/${templateId}`);
  if (response.data.success) {
    return true;
  }
  throw new Error(response.data.message);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/services/TaskService.ts